export default {
  alloyfactorLimitsLabel: 'Granice współczynnika stopu',
  alloyFactorCFerrite: 'Współczynnik stopu C (ferryt)',
  alloyFactorCAustenite: 'Współczynnik stopu C (Austenit)',
  alloyFactorNFerrite: 'Współczynnik stopu N (ferryt)',
  alloyFactorNAustenite: 'Współczynnik stopu N (Austenit)',
  activityCoefficients: 'Współczynniki aktywności',
};
